import styled from 'styled-components';

const Content = styled.div`
  background-color: ${props => props.theme.surface};
  padding: 16px;
  border: 1px solid ${props => props.theme.border_content};
  border-radius: 4px;
`

export default Content;